<p-toast></p-toast>

<div class="page-header">
  <div>
    <h1 class="title">{{ 'GROUPS.TITLE' | translate }}</h1>
    <p class="sub">{{ 'GROUPS.SUBTITLE' | translate }}</p>
  </div>
  <div class="tools">
    <div class="search">
      <i class="pi pi-search"></i>
      <input pInputText [placeholder]="'GROUPS.SEARCH_PLACEHOLDER' | translate" />
    </div>
    <button
      pButton
      icon="pi pi-plus"
      [label]="'GROUPS.NEW_GROUP' | translate"
      (click)="openNew()"
    ></button>
  </div>
</div>

<p-table
  [value]="groups"
  [tableStyle]="{ 'min-width': '64rem' }"
  styleClass="groups-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th>اسم المجموعة</th>
      <th>النظام</th>
      <th>الوصف</th>
      <th class="text-end">إجراءات</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-g>
    <tr>
      <td>
        <div class="g-name">
          <span class="bullet"></span>
          <div class="stack">
            <div class="name">{{ g.name }}</div>
            <div class="chips" *ngIf="g.roles as rs">
              <ng-container *ngIf="rs?.length">
                <span class="chip chip--gray" *ngFor="let r of rs"
                  >{{ r }}</span
                >
              </ng-container>
            </div>
          </div>
        </div>
      </td>

      <td>
        <span class="chip chip--info" *ngIf="g.systemKey; else noSys"
          >{{ g.systemKey }}</span
        >
        <ng-template #noSys>—</ng-template>
      </td>

      <td class="desc">{{ g.description || '—' }}</td>

      <td class="text-end">
        <div class="actions">
          <button
            pButton
            icon="pi pi-pencil"
            class="icon-btn"
            (click)="openEdit(g)"
          ></button>
          <button
            pButton
            icon="pi pi-trash"
            class="icon-btn danger"
            (click)="remove(g)"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="show" [modal]="true" [style]="{ width: '720px' }">
  <ng-template pTemplate="header">
    {{ editId ? 'تعديل مجموعة' : 'مجموعة جديدة' }}
  </ng-template>

  <div class="form-grid">
    <div class="col">
      <div class="field">
        <label>الاسم</label>
        <input pInputText [(ngModel)]="form.name" />
      </div>

      <div class="field">
        <label>النظام</label>
        <p-dropdown
          [options]="systems"
          optionLabel="displayName"
          optionValue="key"
          [(ngModel)]="form.systemKey"
          styleClass="w-full"
        ></p-dropdown>
      </div>

      <div class="field">
        <label>الوصف</label>
        <input pInputText [(ngModel)]="form.description" />
      </div>
    </div>

    <div class="col">
      <div class="field">
        <label>المستخدمون</label>
        <p-multiSelect
          [options]="userOptions"
          [(ngModel)]="form.userIds"
          display="chip"
          [showToggleAll]="false"
          styleClass="w-full"
        ></p-multiSelect>
      </div>

      <div class="field">
        <label>الأدوار</label>
        <p-multiSelect
          [options]="roleOptions"
          [(ngModel)]="form.roleIds"
          display="chip"
          [showToggleAll]="false"
          styleClass="w-full"
        ></p-multiSelect>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="إلغاء"
      class="p-button-secondary"
      (click)="show = false"
    ></button>
    <button pButton label="حفظ" icon="pi pi-save" (click)="save()"></button>
  </ng-template>
</p-dialog>
